// extracted by mini-css-extract-plugin
export var active = "Tile-module--active--4d720";
export var headline = "Tile-module--headline--2826c";
export var icon = "Tile-module--icon--66878";
export var image = "Tile-module--image--333d3";
export var tile = "Tile-module--tile--5d89c";